import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { RFSCreateForm } from "@/features/rfs/RFSCreateForm";

export function RFSCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            label: "Create RFS",
          },
        ]}
      />
      <H2>Create RFS</H2>
      <RFSCreateForm />
    </>
  );
}
